import client from "../client";

/** Contact / help-message endpoints. */
export const contactApi = {
  /** Any authenticated user — submit a new help message. */
  async create(payload) {
    const { data } = await client.post("/contact", payload);
    return data;
  },
  /** Admin only — list every message, optionally filtered by status. */
  async list(status) {
    const params = status ? { status } : undefined;
    const { data } = await client.get("/contact", { params });
    return data;
  },
  /** Admin only — fetch a single message. */
  async get(id) {
    const { data } = await client.get(`/contact/${id}`);
    return data;
  },
  /** Admin only — change message status. */
  async updateStatus(id, status) {
    const { data } = await client.patch(`/contact/${id}/status`, { status });
    return data;
  },
};
